"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Time = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Time = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: "128", cy: "128", r: "96", fill: "none", stroke: "currentcolor", "stroke-miterlimit": "10", "stroke-width": "16" }), (0, jsx_runtime_1.jsx)("polyline", { points: "128 72 128 128 184 128", fill: "none", stroke: "currentcolor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "16" })] })));
};
exports.Time = Time;
